
























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import moment from 'moment';
import { ErrorHelper, LoggingHelper, LogLevel } from 'core-helpers';
import { ReportExportEnum, ReportExportTypes } from '@/Types/ReportExportTypes';
import { FileType } from '@/Types/FileType';
import { User } from '@/models/User';
import Message from '../../../models/Message';
import { GetterTypes as UserGetterTypes } from '../../../store/user/types';
import { ActionTypes as ActionTypesQueue, GetterTypes as GetterTypesQueue } from '../../../store/queues/types';
import { ActionTypes as ActionTypesSnackbar } from '../../../store/snackbar/types';
import QueueList from '../../../components/QueueList/QueueList.vue';
import Queue from '../../../models/Queue';
import QueuesService from '../../../services/QueuesService';
import Slot from '../../../models/Slot';

const queueNamespace: string = 'queue';
const snackbarNamespace: string = 'snackbar';
const userNamespace: string = 'user';

@Component({
  components: { QueueList }
})
export default class QueuesReport extends Vue {
  @Action(ActionTypesQueue.FETCH_QUEUES, { namespace: queueNamespace }) fetchQueues!: (
    scope?: number | null
  ) => Promise<void>;
  @Getter(GetterTypesQueue.GET_QUEUES, { namespace: queueNamespace }) queues!: Queue[];
  @Getter(GetterTypesQueue.GET_QUEUE, { namespace: queueNamespace }) queue!: Queue;
  @Action(ActionTypesSnackbar.SHOW, { namespace: snackbarNamespace }) showSnackbar!: (message: Message) => void;
  @Getter(UserGetterTypes.GET_LOGGED_USER, { namespace: userNamespace }) loggedUser!: User | null;

  // Data table
  private headers = [
    { text: 'Imię', value: 'user.name', sortable: true, filterable: true },
    { text: 'Nazwisko', value: 'user.surname', sortable: true, filterable: true },
    { text: 'Indeks', value: 'user.index', sortable: true, filterable: true },
    { text: 'Nazwa wydziału', value: 'user.unit', sortable: true, filterable: true },
    { text: 'Wydział', value: 'user.unit_short', sortable: true, filterable: true },
    { text: 'Zakończenie studiów', value: 'user.end_of_studies', sortable: true, filterable: true },
    { text: 'Data', value: 'startDate', sortable: true, filterable: true },
    { text: 'Godzina', value: 'startHour', sortable: true, filterable: true }
  ];

  private tableLoading = false;
  private tableSortBy = this.headers[this.headers.length - 1].value;
  private tableSortDesc = true;
  private dataTableSearch = '';

  // Queues selector
  private report: Slot[] = [];
  private selectedQueueUuid: string = '';
  private queuesSelectorLabel = this.$t('global.loading');

  // More options
  private moreOptionsDisabled = true;

  // Time interval
  private startDatePicker = '';
  private endDatePicker = '';

  private startDate: number | null = null;
  private endDate: number | null = null;

  private startDateMenu = false;
  private endDateMenu = false;

  private everythingPeriod = false;

  private shortcutButtonsAcColumn(): boolean {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
      case 'sm':
        return true;
      case 'md':
      case 'lg':
      case 'xl':
        return false;
      default:
        return false;
    }
  }

  // Export
  private exportOptions = Object.values(ReportExportEnum);
  private currentExportOption: ReportExportTypes = ReportExportEnum.CSV;
  private exportDialogVisibility = false;
  private exportHelpTextTimer: number | null = null;
  private exportHelpTextTimeDelay = 5000; // 5000 ms ~ 5s
  private exportHelpTextVisibility = false;
  private exportIsFileGenerated = false;
  private exportedFile: FileType | null = null;
  private exportedFileName = '';
  private exportedFileLink = '';

  // Other
  private queueListLoading = false;

  private queuesService: QueuesService = new QueuesService();

  private async mounted(): Promise<void> {
    this.headers = [
      {
        text: this.$t('meeting.presenceReports.report.headers.name') as string,
        value: 'user.name',
        sortable: true,
        filterable: true
      },
      {
        text: this.$t('meeting.presenceReports.report.headers.surname') as string,
        value: 'user.surname',
        sortable: true,
        filterable: true
      },
      {
        text: this.$t('meeting.presenceReports.report.headers.index') as string,
        value: 'user.index',
        sortable: true,
        filterable: true
      },
      {
        text: this.$t('meeting.presenceReports.report.headers.unitName') as string,
        value: 'user.unit',
        sortable: true,
        filterable: true
      },
      {
        text: this.$t('meeting.presenceReports.report.headers.unit') as string,
        value: 'user.unit_short',
        sortable: true,
        filterable: true
      },
      {
        text: this.$t('meeting.presenceReports.report.headers.end_of_studies') as string,
        value: 'user.end_of_studies',
        sortable: true,
        filterable: true
      },
      {
        text: this.$t('meeting.presenceReports.report.headers.date') as string,
        value: 'startDate',
        sortable: true,
        filterable: true
      },
      {
        text: this.$t('meeting.presenceReports.report.headers.hour') as string,
        value: 'startHour',
        sortable: true,
        filterable: true
      }
    ];

    if (
      this.loggedUser &&
      (this.loggedUser.roles.includes('super administrator') || this.loggedUser.roles.includes('administrator'))
    ) {
      if (this.queues && this.queues.length) {
        this.selectedQueueUuid = this.queues[0].uuid;
      } else {
        await this.getQueues();
      }
      await this.todayTimeInterval();
    } else {
      await this.$router.push('/app');
    }
  }

  private async getSelectedQueue(dateChange: boolean = false): Promise<void> {
    const queueUuid: string | null = this.selectedQueueUuid;

    this.report = [];

    if (queueUuid == null) {
      return;
    }

    let start: number | null = null;
    let end: number | null = null;

    if (dateChange && !this.everythingPeriod) {
      start = this.startDate;
      end = this.endDate;
    }

    try {
      this.tableLoading = true;
      const data = await this.queuesService.fetchReport(queueUuid, start, end);

      if (data.slots.length > 0) {
        data.slots.map((slot: Slot) => {
          slot.startHour = moment(+slot.startDate * 1000).format('H:mm');
          slot.endHour = moment(+slot.endDate * 1000).format('H:mm');
          slot.startDate = moment(+slot.startDate * 1000).format('yyyy-MM-DD');
          slot.endDate = moment(+slot.endDate * 1000).format('yyyy-MM-DD');
          return slot;
        });

        if (!dateChange) {
          this.startDatePicker = data.slots[0].startDate as string;
          this.endDatePicker = data.slots[data.slots.length - 1].endDate as string;
        }

        this.report = data.slots;
      } else {
        this.report = [];
      }
    } catch (err: unknown) {
      const error = ErrorHelper.getAxiosError(err);

      if (error) {
        const { status } = error;

        switch (status) {
          case 403:
            this.showSnackbar({ message: this.$t('globals.forbidden') as string, color: 'error' });
            break;
          default:
            this.showSnackbar({
              message: this.$t('meeting.presenceReports.errors.general') as string,
              color: 'warning'
            });
            break;
        }
      }

      LoggingHelper.log(err, LogLevel.ERROR);
    }

    this.tableLoading = false;
  }

  private async getQueues(): Promise<void> {
    try {
      this.moreOptionsDisabled = true;
      this.queueListLoading = true;

      await this.fetchQueues(2);

      this.queuesSelectorLabel = this.$t('admin.queues-report.queue-selector');
      this.selectedQueueUuid = this.queues[0].uuid;
      await this.getSelectedQueue();
    } catch (err: unknown) {
      const error = ErrorHelper.getAxiosError(err);

      if (error) {
        const { status } = error;

        switch (status) {
          case 403:
            this.showSnackbar({ message: this.$t('globals.forbidden') as string, color: 'error' });
            break;
          default:
            this.showSnackbar({ message: this.$t('globals.unknownError') as string, color: 'warning' });
            break;
        }
      }

      LoggingHelper.log(err, LogLevel.ERROR);
    }

    this.queueListLoading = false;
  }

  @Watch('startDatePicker')
  private updateStartDate(): void {
    if (this.startDatePicker && this.startDatePicker.length) {
      this.startDate = moment(this.startDatePicker).startOf('day').unix();
    }
    this.getSelectedQueue(true);
  }

  @Watch('endDatePicker')
  private updateEndDate(): void {
    if (this.endDatePicker && this.endDatePicker.length) {
      this.endDate = moment(this.endDatePicker).endOf('day').unix();
    }

    this.getSelectedQueue(true);
  }

  private async resetTimeInterval(): Promise<void> {
    this.startDate = null;
    this.endDate = null;

    this.startDatePicker = '';
    this.endDatePicker = '';

    this.everythingPeriod = false;
    await this.getSelectedQueue(true);
  }

  private async setTimePeriod(period: any): Promise<void> {
    this.startDate = moment().startOf(period).unix();
    this.endDate = moment().endOf(period).unix();
    this.startDatePicker = moment().startOf(period).format('yyyy-MM-DD');
    this.endDatePicker = moment().endOf(period).format('yyyy-MM-DD');

    this.everythingPeriod = false;
    await this.getSelectedQueue(true);
  }

  private async todayTimeInterval(): Promise<void> {
    await this.setTimePeriod('day');
  }

  private async weekTimeInterval(): Promise<void> {
    await this.setTimePeriod('week');
  }

  private async monthTimeInterval(): Promise<void> {
    await this.setTimePeriod('month');
  }

  private async allTimeInterval(): Promise<void> {
    await this.resetTimeInterval();

    this.everythingPeriod = true;
  }

  @Watch('selectedQueueUuid')
  private onSelectedQueueUuidChange() {
    this.moreOptionsDisabled = this.queues.length <= 0;
  }

  private getWidthSize(): string {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
      case 'sm':
        return '100%';
      case 'md':
      case 'lg':
      case 'xl':
        return '150px';
      default:
        return '100%';
    }
  }

  private async downloadReport(): Promise<void> {
    this.exportIsFileGenerated = false;
    this.exportDialogVisibility = true;
    this.exportHelpTextVisibility = false;

    this.exportHelpTextTimer = setTimeout(() => {
      this.exportHelpTextVisibility = true;
    }, this.exportHelpTextTimeDelay);

    try {
      this.exportedFile = await this.queuesService.downloadReport(
        this.selectedQueueUuid,
        this.currentExportOption,
        this.startDate,
        this.endDate
      );

      // @ts-ignore
      this.exportedFileLink = window.URL.createObjectURL(this.exportedFile.file);
      this.exportedFileName = `${this.exportedFile.name}.${this.exportedFile.extension}`;
      this.exportIsFileGenerated = true;
    } catch (err: unknown) {
      const error = ErrorHelper.getAxiosError(err);

      if (error) {
        const { status } = error;

        switch (status) {
          case 403:
            this.showSnackbar({ message: this.$t('globals.forbidden') as string, color: 'error' });
            break;
          default:
            break;
        }
      }

      LoggingHelper.log(err, LogLevel.ERROR);
      this.exportDialogVisibility = false;
    }

    this.exportHelpTextVisibility = false;
  }

  private triggerFileDownload(): void {
    const link: HTMLLinkElement = this.$refs.downloadLink as HTMLLinkElement;
    link.click();
    this.exportDialogVisibility = false;
  }
}
